import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Batiment} from "../Models/Batiment";
import {AppComponent} from "../app.component";
import * as _ from "lodash";
import {forEach} from "lodash";
import {loadStripe} from '@stripe/stripe-js';
import {environment} from 'src/environments/environment';
import {UserTypeEnum} from "../enums/user-type.enum";
import {StripeProductsList} from "../const/stripe-products-list";
import {ProductsHelper} from "../helpers/products.helper";

@Component({
	selector: 'app-produits',
	templateUrl: './produits.component.html',
	styleUrls: ['./produits.component.less'],
	encapsulation: ViewEncapsulation.None
})
export class ProduitsComponent implements OnInit {
	private stripePromise = loadStripe(environment.stripePublishableKey);
	taxe_tva: number = 0.2;
	textes: any = "";
	globalTxt: any = "";
	batiment: Batiment = JSON.parse(localStorage.getItem("BATIMENT")!);
	token: any = JSON.parse(localStorage.getItem("token")!);
	produits: any = [];

	constructor(
		public app: AppComponent,
		public productsHelper: ProductsHelper
	) {
	}

	ngOnInit(): void {
		if (!this.app.sharedToolsService.getIfSessionExists()) {
			this.app.router.navigate(['/']);
			return;
		}

		// Load the nameJson and initialize the component
		this.app.dataInitService.getNameJsonReady((nameJson) => {
			this.getInfosInit(nameJson);
		});
	}

	getInfosInit(_nameJson: any) {
		// Get Settings
		this.app.sharedToolsService.getSettings();

		// Get the global texts
		this.app.dataInitService.getGlobalTextsOnce(globalTxt => {
			this.globalTxt = globalTxt;

			// Get the texts
			this.app.sharedToolsService.loadTexts(_nameJson)
				.subscribe(textes => {
					this.textes = textes;

					// Get Products
					this.getStripeProducts();
				});
		});
	}

	calculatePriceVat(price: number, taxe: number) {
		return price + taxe;
	}

	getStripeProducts() {
		// ==> Get Stripe data
		this.app.apiToolsService.getAllStripeProducts().subscribe(res => {
			console.log("res getAllStripeProducts ==> ", res);

			this.produits = [];
			let yearlyPrice: any[] = [];
			let produit: any = {};

			forEach(res, (p: any) => {
				produit = _.find(StripeProductsList, {ProductId: p.ProductId});
				let referential: string = this.app.sharedToolsService.returnObjectSwitchRefId();

				if (produit
					&& produit.showInRefs?.includes(referential)
					//&& produit.showInRefIds?.indexOf(this.token?.refId) != -1
					&& produit.showInUserTypes?.indexOf(this.token?.usrType) != -1) {
					if (!produit.parentProductId) {
						this.produits.push({
							productId: p.ProductId,
							priceId: p.PriceId,
							recurringInterval: p.RecurringInterval,
							label: this.productsHelper.getProductTexts(p.ProductName, "label"),
							icon: (p.RecurringInterval != null) ? "produit_abonnement" : "produit_oneshot",
							texte: this.productsHelper.getProductTexts(p.ProductName, "text"),
							price: p.UnitAmount / 100,
							priceTva: this.calculatePriceVat((p.UnitAmount / 100), (p.UnitAmount / 100 * this.taxe_tva)),
							btnLabel: this.textes.labelBtnValider,
							bottomText: this.productsHelper.getProductTexts(p.ProductName, "bottomText")
						});
					} else {
						yearlyPrice.push({
							productId: p.ProductId,
							priceId: p.PriceId,
							recurringInterval: p.RecurringInterval,
							label: this.productsHelper.getProductTexts(p.ProductName, "label"),
							icon: (p.RecurringInterval != null) ? "produit_abonnement" : "produit_oneshot",
							texte: this.productsHelper.getProductTexts(p.ProductName, "text"),
							price: p.UnitAmount / 100,
							priceTva: this.calculatePriceVat((p.UnitAmount / 100), (p.UnitAmount / 100 * this.taxe_tva)),
							btnLabel: this.textes.labelBtnValider,
							bottomText: this.productsHelper.getProductTexts(p.ProductName, "bottomText"),
							parentProductId: produit.parentProductId,
						});
					}
				}
			});

			if (yearlyPrice.length > 0) {
				forEach(yearlyPrice, (yp) => {
					let parent = _.find(this.produits, {productId: yp.parentProductId});
					console.log("parent ==> ", parent);
					if (parent) {
						parent.yearlyOffer = yp;
					}
				})
			}

			console.log("this.produits ==> ", this.produits);

			var referer: any = JSON.parse(localStorage.getItem("referer")!);

			if (referer) {
				this.produits.pop();

				this.produits.push({
					productId: "prod_RefererFree",
					priceId: "price_RefererFree",
					recurringInterval: null,
					label: "2 estimations",
					icon: "produit_oneshot",
					texte: "Vos 2 premières estimations offertes !",
					price: 0.0,
					btnLabel: this.textes.labelBtnValider,
				});
			}
		});
	}
}
